export default "__VITE_ASSET__BERsBXFU__"